import { DeleteTeamEventDetails, Team } from "@/types/types";
import { CustomEventType } from "@/events/CustomEventRegistry";
import { getTeamColorOptions } from "@/utils/teamColorPalette";
import { LitElement, css, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { EventFormSectionStyles } from "./SectionStyles";

import "@/components/color-picker/TeamColorPicker";

@customElement("add-team-card")
export class AddTeamCard extends LitElement {
	static readonly styles = [EventFormSectionStyles, css`
    span {
        font-family: var(--font-text);
        font-size: var(--font-size-text);
        color: black;
        line-height: var(--line-height-text);
        margin: 0px;
    }
    .team-card {
        border:
        2px solid #e0e0e0;
        border-radius: 8px;
        padding: 20px;
        margin-bottom: 20px;
        background: white;
        transition: all 0.3s ease;
    }
    .team-card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 15px;
        padding-bottom: 10px;
        border-bottom: 1px solid #f0f0f0;
    }
	.team-card-header--team-name-section {
		display: flex;
		gap: 8px;
		align-items: center;
	}
	`,];

	@property({ type: Object }) team: Team;
	@property({ type: Number }) teamIndex = 0;

	private _handleDeleteTeam = () => {
		const deleteEvent = new CustomEvent<DeleteTeamEventDetails>(CustomEventType.DELETE_TEAM, {
			detail: { teamIndex: this.teamIndex },
			bubbles: true,
			composed: true
		});
		this.dispatchEvent(deleteEvent);
	};

	private _handleColorPicked = (event: CustomEvent<{ color: string }>) => {
		event.stopPropagation();
		this.dispatchEvent(new CustomEvent(CustomEventType.TEAM_COLOR_CHANGE, {
			detail: { teamIndex: this.teamIndex, newColor: event.detail.color },
			bubbles: true,
			composed: true,
		}));
	};

	render() {
		return html`
        <div class="team-card">
            <div class="team-card-header">
                <div class="team-card-header--team-name-section">
                    <team-color-picker
                        .selectedColor=${this.team.color}
                        .options=${getTeamColorOptions()}
                        @color-picked=${this._handleColorPicked}
                    ></team-color-picker>
                    <span>Team #${this.team.team_number}</span>
                </div>
                <alert-button type="button" @click="${this._handleDeleteTeam}">
                    Entfernen
                </alert-button>
            </div>
            <div class="form-row">
                <basic-input
                    inputEventIdentifier="team-${this.teamIndex}"
                    label="Teamname"
                    name="name"
                    style="flex: 1;"
                    value="${this.team.name || ''}"
                ></basic-input>
            </div>
            <div class="form-row">
                <basic-input
                    helperText="Die Namen müssen mit Komma getrennt werden"
                    inputEventIdentifier="team-${this.teamIndex}"
                    label="Teammitglieder"
                    name="players"
                    style="flex: 1;"
                    value="${this.team.players.map(player => player.name).join(', ') || ''}"
                ></basic-input>
            </div>
        </div>
    `;
	}
}

export default AddTeamCard;
